const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.533 392.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M235.572,359.822c0,6.012,4.848,10.925,10.925,10.925h113.325c6.012,0,10.925-4.848,10.925-10.925 v-17.907H235.572V359.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M359.822,123.798H246.497c-6.012,0-10.925,4.848-10.925,10.925v17.907h135.176v-17.907 C370.747,128.646,365.834,123.798,359.822,123.798z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.572,
    y: 174.481,
    style: {
      fill: "none"
    },
    width: 135.176,
    height: 145.648
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M359.822,102.012H246.497c-18.036,0-32.711,14.675-32.711,32.711v225.099 c0,18.036,14.675,32.711,32.711,32.711h113.325c18.036,0,32.711-14.675,32.711-32.711V134.659 C392.533,116.687,377.859,102.012,359.822,102.012z M370.747,359.822c0,6.012-4.848,10.925-10.925,10.925H246.497 c-6.012,0-10.925-4.848-10.925-10.925v-17.907h135.176V359.822z M370.747,320.065H235.572V174.481h135.176V320.065z  M370.747,152.63H235.572v-17.907c0-6.012,4.848-10.925,10.925-10.925h113.325c6.012,0,10.925,4.848,10.925,10.925V152.63 L370.747,152.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M276.428,275.071c6.012,0,10.925-4.848,10.925-10.925v-17.39l34.909,34.909 c4.267,4.267,11.119,4.267,15.451,0c4.267-4.267,4.267-11.119,0-15.451l-34.909-34.909h17.325c6.012,0,10.925-4.848,10.925-10.925 c0-6.012-4.848-10.925-10.925-10.925h-43.701c-6.012,0-10.925,4.848-10.925,10.925v43.636 C265.503,270.222,270.352,275.071,276.428,275.071z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M146.036,21.786H32.711c-6.012,0-10.925,4.848-10.925,10.925V257.81 c0,6.012,4.848,10.925,10.925,10.925h113.39c6.012,0,10.925-4.848,10.925-10.925V32.711 C156.962,26.699,152.048,21.786,146.036,21.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M146.036,0H32.711C14.675,0,0,14.675,0,32.711V257.81c0,18.101,14.675,32.776,32.711,32.776h113.39 c18.036,0,32.711-14.675,32.711-32.711V32.711C178.747,14.675,164.073,0,146.036,0z M156.962,257.875 c0,6.012-4.848,10.925-10.925,10.925H32.711c-6.012,0-10.925-4.848-10.925-10.925V32.711c0-6.012,4.848-10.925,10.925-10.925h113.39 c6.012,0,10.925,4.848,10.925,10.925v225.164H156.962z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.572,
    y: 77.834,
    style: {
      fill: "none"
    },
    width: 91.475,
    height: 134.853
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M75.507,59.539h27.798c6.012,0,10.925-4.848,10.925-10.925s-4.848-10.925-10.925-10.925H75.507 c-6.012,0-10.925,4.848-10.925,10.925S69.43,59.539,75.507,59.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M95.806,231.046H82.812c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h12.994c6.012,0,10.925-4.848,10.925-10.925C106.731,235.895,101.818,231.046,95.806,231.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M116.105,117.463c-6.012,0-10.925,4.848-10.925,10.925v17.325l-34.909-34.844 c-4.267-4.267-11.119-4.267-15.451,0c-4.267,4.267-4.267,11.119,0,15.451l34.909,34.909H72.404 c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925h43.701c6.012,0,10.925-4.848,10.925-10.925v-43.636 C127.03,122.311,122.182,117.463,116.105,117.463z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.8c842fc7b604818fdf6defc2f92ed60e.svg";
export { ForwardRef as ReactComponent };